module.exports = __webpack_public_path__ + "f4e58e544b2011271567462783a81391.svg";